
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_9a8vd_99",
  "textarea": "awsui_textarea_qk1j1_9a8vd_103",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_9a8vd_156",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_9a8vd_198"
};
  